module.exports = __webpack_public_path__ + "static/media/EnvironmentalRacism.c8505370.jpg";